import Modal from './Modal'
import {
  ModalContainer,
  RegisterModal,
  useModalRegistry,
} from './ModalContainer'

export { Modal, ModalContainer, RegisterModal, useModalRegistry }

export * from './Modal'
